<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ct" id="toc_marker-6"><a href="#/Hidden_Heritage2#Contents-A">Epigraph</a></p>
<p class="fp para-style-override-5"><span class="Italic">Take the staff, and you and your brother Aaron gather the assembly together. Speak to that rock before their eyes and it will pour out its water. You will bring water out of the rock for the community so they and their livestock can drink.</span></p>
<p class="body para-style-override-6">—Numbers 20:8 (NIV)</p>
<p class="body para-style-override-7"></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Hidden_Heritage-5.vue?bcdeb9e8